module.exports = __webpack_public_path__ + "img/greenIsland-small.f17081a5.svg";